export default __webpack_public_path__ + "static/media/icon-pgto.adc1c387.svg";